/** Domyślny opis HTML przy dodawaniu terminu certyfikacji (edytowalny przed zapisem). */
export default `<p>Certyfikacja dotyczy ścieżki: {rodzaj_certyfikacji}.</p>
<p>Termin certyfikacji: {data_certyfikacji}, godz. {godzina_certyfikacji}<br>
Lokalizacja: {lokalizacja}</p>
<p>Warunkiem przystąpienia do certyfikacji jest ukończenie wymaganych szkoleń oraz spełnienie warunków udziału zgodnie z zasadami programu certyfikacyjnego.</p>
<p>W przypadku pytań prosimy o kontakt z organizatorem certyfikacji</p>`
